module.exports = __webpack_public_path__ + "img/PL08815.3660fe1b.png";